import React, { useState, useEffect } from "react";
import { Card, Row, Col, Table } from "antd";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import { DebtService } from "../services/debt-service";
import { loadAppConfig } from "../../../config/app-config";
import { useId24 } from "../../../drivers/id24/Id24-provider";
const appConfig = loadAppConfig();

export interface Props {
  baseURL: string;
  caption: string;
  accountNo: string;
  loading: boolean;
  cifId: string;
  addActionStatus: string;
}

export const DebtTrackHistory: React.FC<Props> = ({ caption, accountNo, baseURL, loading, cifId, addActionStatus }): React.ReactElement => {
  const debtService = DebtService;
  const { tokenAccess, login, logout, id24Axios } = useId24();
  const apiBaseUrl = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);

  const [resData, setResData] = useState([]);
  const [userProfile, setUserprofile] = useState<any>([]);
  useEffect(() => {
    getUserProfile().then(async (data) => {
      setUserprofile(data.result);
      await getTrackHistory();
    });
  }, [cifId, addActionStatus, accountNo]);

  const getUserProfile = async () => {
    return new Promise<any>(async (resolve, reject) => {
      const resultProfile = await debtService(apiBaseUrlDebt).getUserList();
      resolve(resultProfile);
    });
    // const result: any = await debtService().getUserList();
    // setUserprofile(result.result);
    // console.log(result.result);
  };
  const getTrackHistory = async () => {
    let result = (await debtService(apiBaseUrlDebt).getDebtWrapup(cifId, accountNo)) as any;
    let last = result.result.length + 1;
    const data = (await result.result.map(
      (
        x: {
          actionCodeName: string;
          contact: string;
          phone: string;
          statusCodeName: string;
          paymentDate: string;
          paymentAmt: string;
          remark: string;
          debt_id: string;
          cif: string;
          user_id: string;
          appointmentDate: string;
          createDate: string;
          userId: string;
          collName: string;
          measure: string;
        },
        index: number,
      ) => {
        const mapData = {
          num: index + 1,
          trackDate: dayjs(x.createDate).add(543, "year").format("DD-MM-YYYY"),
          trackTime: dayjs(x.createDate).format("HH:mm"),
          trackCust: x.contact,
          actionCode: x.actionCodeName,
          statusCode: x.statusCodeName,
          paymentDate: x.paymentDate,
          paymentAmount: x.paymentAmt,
          appointmentDate: x.appointmentDate,
          remark: x.remark,
          collector: x.userId,
          trackDateTime: x.createDate,
          collName: x.collName,
          measure: x.measure,
          phone: x.phone,
        };
        return mapData;
      },
    )) as any;
    setResData(data);
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "num",
      key: "num",
      width: 50,
    },
    {
      title: "วันที่ติดตาม",
      dataIndex: "trackDate",
      key: "trackDate",
      width: 120,
      sorter: (a: any, b: any) => a.trackDateTime.localeCompare(b.trackDateTime),
      defaultSortOrder: "descend" as any,
    },
    {
      title: "เวลาที่ติดตาม",
      dataIndex: "trackTime",
      key: "trackTime",
      width: 120,
      render: (text: string) => text + "น.",
    },
    {
      title: "บุคคลที่ติดต่อ",
      dataIndex: "trackCust",
      key: "trackCust",
      width: 200,
    },
    {
      title: "เบอร์ที่ติดต่อ",
      dataIndex: "phone",
      key: "phone",
      width: 200,
    },
    {
      title: "Action Code",
      dataIndex: "actionCode",
      key: "actionCode",
      width: 180,
    },
    {
      title: "Status Code",
      dataIndex: "statusCode",
      key: "statusCode",
      width: 180,
    },
    {
      title: "วันที่นัดชำระ",
      dataIndex: "paymentDate",
      key: "paymentDate",
      width: 120,
      render: (text: string) => (text !== "" && text !== null ? dayjs(text).locale("th").add(543, "year").format("DD-MM-YYYY") : "-"),
    },
    {
      title: "จำนวนเงินที่นัดชำระ",
      dataIndex: "paymentAmount",
      key: "paymentAmount",
      width: 200,
      align: "right" as const,
      render: (text: string, record: any, index: number) => (
        <NumberFormat value={text} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} />
      ),
    },
    {
      title: "วันที่นัดหมาย",
      dataIndex: "appointmentDate",
      key: "appointmentDate",
      width: 120,
      render: (text: string) => (text !== "" && text !== null ? dayjs(text).locale("th").add(543, "year").format("DD-MM-YYYY") : "-"),
    },
    {
      title: "รายงานผลการติดตามหนี้",
      dataIndex: "remark",
      key: "remark",
      width: 250,
    },
    {
      title: "มาตรการ",
      dataIndex: "measure",
      key: "measure",
      width: 200,
      render: (measure: string) => (measure === "" || measure === null ? "-" : measure),
    },
    {
      title: "Collector",
      dataIndex: "collName",
      key: "collName",
      width: 200,
      // render: (text: string) => {
      //   let userName;
      //   userProfile.map((x: any) => {
      //     if (Number(x?.id) === Number(text)) {
      //       userName = x?.name;
      //     }
      //   });
      //   return <Col>{userName}</Col>;
      // },
    },
  ];

  return (
    <>
      <h1>ประวัติการติดตามของพนักงาน </h1>
      <Table size="large" dataSource={resData} columns={columns} rowKey={(record: any) => record.num} scroll={{ x: 2000 }} />
    </>
  );
};
